<template>
  <div class="tab-history-wrap section-space--mt_80">
    <div class="row">
      <div class="col-lg-7">
        <div class="tab-history-image">
          <img
            src="../../../assets/img/banners/aeroland-tab-content-image-04.png"
            alt=""
            class="img-fluid"
          />
        </div>
      </div>
      <div class="col-lg-5 d-flex align-items-center">
        <div class="tab-content-inner">
          <!-- <h4 class="font-weight--light">Title 1</h4> -->
          <ul
            class="
              check-list
              green-check-list
              section-space--mb_50 section-space--mt_50
            "
          >
            <li
              class="list-item text-white"
              v-for="(each, index) in services"
              :key="index"
            >
              {{ each }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [
        "需求分析",
        "科技諮詢",
        "團隊開發",
        "用戶測試（UAT）",
        "系統維護",
        "售後服務",
        "升級方案",
      ],
    };
  },
};
</script>

<style scoped>
.check-list.green-check-list .list-item::before {
  color: #5e76c1;
}

.check-list .list-item {
  font-size: 1.2rem;
}
</style>

